import styled from 'styled-components';

import MdIcon from '~/shared/components/mdIcon';

export const Wrapper = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  height: fit-content;
  @media (min-width: 760px) {
    width: 100%;
  }
`;

export const HeaderContainer = styled.div``;
export const IconClick = styled.div``;

export const Header = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  /* font-family: 'Rubik'; */
  text-align: center;
  padding: 20px;
  margin: 0 20px;
  justify-content: center;
  border-bottom: 1px solid ${(props) => props.theme.palette.lightTransparency};
  @media (min-width: 760px) {
    min-width: 100%;
    margin: 0px;
  }
  img {
    width: 170px;
  }
  :after {
    width: 100%;
    content: ' ';
    /* background: ${(props) => props.theme.palette.primary.main}; */
    position: absolute;
    height: ${(props) => props.BackgroundHeight || 'unset'};
    top: 0;
    z-index: -2;
  }
`;

export const HelpBackgroundHeader = styled.div`
  width: 100%;
  content: ' ';
  background: ${(props) => props.theme.palette.primary.main};
  height: ${(props) => props.BackgroundHeight || 'unset'};
  margin-bottom: -${(props) => props.BackgroundHeight || 'unset'};
`;

export const Title = styled.div`
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  text-align: center;
  font-family: 'Rubik';
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0px;
  color: ${(props) => props.theme.palette.primary.contrastText};
  opacity: 1;
  padding: ${(props) => props.theme.spacing.small} 0px;
`;

export const Document = styled.div`
  top: 0px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  z-index: 10;
  opacity: 1;
  flex: 1 1 auto;
  padding: 0px 16px 120px;
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  border-image: initial;
  transition: opacity 0.25s linear 0s;
  flex-grow: 1;
  width: 100%;
  height: fit-content;
  background: transparent linear-gradient(180deg, #ffffff 0%, #f7f7fa 100%) 0%
    0% no-repeat padding-box;
`;

export const HelpContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 30px 20px;
  width: 100%;
`;

export const TitleContainer = styled.div`
  width: 100%;
  text-align: center;
`;

export const SubTitle = styled.h2`
  display: flex;
  font-size: 18px;
  color: ${(props) => props.theme.palette.primary.main};
  font-weight: 600;
  margin: 23px auto;
  flex-wrap: wrap;
  max-width: 100%;
`;

export const Text = styled.p`
  text-align: center;
  margin: ${({ margin }) => margin || '0 22px 24px 22px'};
  color: ${({ theme }) => theme.palette.gray3};
  font-size: 14px;
`;

export const CodeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-flow: column;
  /* margin-bottom: ${({ theme }) => theme.spacing.small}; */
`;

export const QrCodeImage = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
  background: white;
  padding: 20px;
  box-shadow: 0px 4px 14px ${(props) => props.theme.palette.darkTransparency};
  border-radius: 12px;
`;

export const TokenDetail = styled.div`
  vertical-align: baseline;
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
`;

export const CodeTextUpper = styled.p`
  text-align: inherit;
  color: ${({ theme: { palette } }) => palette.primary.main};
  font-size: 24px;
  line-height: 32px;
  letter-spacing: normal;
  font-weight: 400;
  opacity: 1;
  margin: 0;
`;

export const StyledIcon = styled(MdIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const IconContainer = styled.div`
  position: absolute;
  left: 0;
  padding-left: 24px;
  cursor: pointer;

  @media (max-width: 320px) {
    padding-left: 0px;
  }
`;

export const QrCodeLink = styled.div`
  display: flex;
  color: ${(props) => props.theme.palette.gray1};
  flex-wrap: wrap;
  text-align: center;
  max-width: 100%;
  margin: 10px auto;
  font-size: 14px;
  img {
    margin: 0px 5px;
  }
  a {
    color: ${(props) => props.theme.palette.gray1};
  }
  @media (max-width: 330px) {
    font-size: 14px;
    img {
      margin: 0px 3px;
    }
  }
`;
